/* eslint-disable */
// AUTO-GENERATED FILE. DO NOT EDIT MANUALLY.

export const GENERATED_PROVIDERS_PATHS: string[] = [
    "game-providers/1spin4win",
    "game-providers/1x2-gaming",
    "game-providers/799",
    "game-providers/924",
    "game-providers/975",
    "game-providers/991",
    "game-providers/absolute-live-gaming",
    "game-providers/apollo",
    "game-providers/avatarux",
    "game-providers/aviatrix",
    "game-providers/barbara-bang",
    "game-providers/belatra",
    "game-providers/betsolutions",
    "game-providers/bgaming",
    "game-providers/bi-time",
    "game-providers/champion",
    "game-providers/clawbuster",
    "game-providers/endorphina",
    "game-providers/evolution",
    "game-providers/evolutionzen",
    "game-providers/evoplay",
    "game-providers/ezugi",
    "game-providers/fantasma",
    "game-providers/fazi",
    "game-providers/fugaso",
    "game-providers/gamebeat",
    "game-providers/gamzix",
    "game-providers/hacksawgaminggr",
    "game-providers/igrosoft",
    "game-providers/imoon",
    "game-providers/inout",
    "game-providers/iron-dog-studio",
    "game-providers/kagaming",
    "game-providers/kalamba",
    "game-providers/luckystreak",
    "game-providers/mancalagaming",
    "game-providers/mascot",
    "game-providers/mrslotty",
    "game-providers/netent",
    "game-providers/nolimitcity",
    "game-providers/novomatic",
    "game-providers/one-touch",
    "game-providers/onlyplay",
    "game-providers/pateplay",
    "game-providers/platipus",
    "game-providers/platipuslive",
    "game-providers/playbro",
    "game-providers/playngo",
    "game-providers/popiplay",
    "game-providers/pragmatic-live-zen",
    "game-providers/pragmatic-play-zen",
    "game-providers/redtigergaming",
    "game-providers/retrogaming",
    "game-providers/rubyplay",
    "game-providers/spadegaming",
    "game-providers/spinomenal",
    "game-providers/spribe",
    "game-providers/swintt",
    "game-providers/thunderspin",
    "game-providers/tom-horn",
    "game-providers/triplecherry",
    "game-providers/voltent",
    "game-providers/yggdrasil",
    "game-providers/zillion"
];

export const GENERATED_CATEGORY_PATHS: string[] = [
    "game-categories/baccarat",
    "game-categories/blackjack",
    "game-categories/jackpot",
    "game-categories/live-casino",
    "game-categories/poker",
    "game-categories/popular",
    "game-categories/provably-fair",
    "game-categories/roulette",
    "game-categories/slots",
    "game-categories/top",
    "game-categories/valentines",
    "game-categories/wager-slots"
];

